import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, IStateInfoDto } from '@/dtos';

export const MAX_OPTIONS_COUNT_STATES = 300;

export interface StatePayload {
  id: number;
  code: string;
  name: string;
}

const formatData = (states: IStateInfoDto[]) =>
  states
    .map((state) => ({
      id: toString(state.id),
      code: state.code,
      key: state.code || '',
      name: state.name || '',
      title: state.name || '',
      value: state.name || '',
    }))
    .sort((a, b) => (a.name < b.name ? -1 : 1));

const useStatesQuery = () => {
  const { isLoading, isSuccess, isError, data } = useQuery([API_URL.ENUMS_STATES], () =>
    api.get(API_URL.ENUMS_STATES)
  );

  const states = useMemo(() => formatData(data?.data || []), [data]);
  return {
    states,
    isError,
    isLoading,
    isSuccess,
  };
};

export default useStatesQuery;
